<template>
  <v-container fluid class="inicio-dashboard px-3 px-md-8 py-4">
    <v-alert
      v-if="userLogged.b_castigado"
      outlined
      type="warning"
      dense
      prominent
      class="mb-4"
    >
      {{ userLogged.msg_castigado }}
    </v-alert>

    <v-row v-if="loading" align-content="center" justify="center" class="my-8">
      <v-col cols="12">
        <cargando-app text="Cargando Datos..." />
      </v-col>
    </v-row>

    <template v-else>
      <v-row class="dashboard-row">
        <v-col cols="12" lg="4">
          <v-card elevation="6" class="patrimonio-card rounded-xl pa-5 fill-height">
            <div class="patrimonio-content">
              <div>
                <div class="white--text dashboard-label">
                  Patrimonio total
                  <!-- <v-icon small color="white" class="ml-1">mdi-eye-outline</v-icon> -->
                </div>
                <div class="patrimonio-amount">{{ formatMonto(inicioData.patrimonio.total) }}</div>
                <div class="white--text patrimonio-subtitle"></div>
                <!-- <div class="white--text patrimonio-subtitle">Activo en productos</div> -->
                <div class="patrimonio-meta mt-5">
                  <span class="patrimonio-products">
                    <v-icon x-small color="#d9f48f" class="mr-1">mdi-arrow-right-top</v-icon>
                    {{ activeProductsCount }} productos activos
                  </span>
                </div>
              </div>
              <div class="patrimonio-icon-wrap">
                <div class="patrimonio-icon-ring">
                  <v-icon color="white" size="42">mdi-badge-account-horizontal</v-icon>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" lg="8">
          <v-card elevation="4" class="dashboard-card personal-card rounded-xl fill-height">
            <div class="personal-header">
              <div class="personal-title-wrap">
                <v-avatar color="rgba(36, 202, 212, 0.16)" size="42" class="mr-3">
                  <v-icon color="primary">mdi-account</v-icon>
                </v-avatar>
                <div>
                  <div class="personal-title">Información personal</div>
                  <div class="personal-subtitle">Datos de contacto registrados</div>
                </div>
              </div>
            </div>
            <div class="personal-content">
              <div class="personal-item">
                <div class="personal-icon personal-icon-primary">
                  <v-icon color="primary" size="24">mdi-map-marker</v-icon>
                </div>
                <div class="personal-copy">
                  <span class="personal-label">Dirección</span>
                  <strong>{{ personalInfo.direccion }}</strong>
                </div>
              </div>
              <div class="personal-item">
                <div class="personal-icon personal-icon-secondary">
                  <v-icon color="primary" size="24">mdi-cellphone</v-icon>
                </div>
                <div class="personal-copy">
                  <span class="personal-label">Móvil</span>
                  <strong>{{ personalInfo.movil }}</strong>
                </div>
              </div>
              <div class="personal-item">
                <div class="personal-icon personal-icon-accent">
                  <v-icon color="primary" size="24">mdi-email</v-icon>
                </div>
                <div class="personal-copy">
                  <span class="personal-label">Correo personal</span>
                  <strong>{{ personalInfo.email }}</strong>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="dashboard-row">
        <v-col v-for="product in inicioData.productos" :key="product.key" cols="12" sm="6" lg="3">
          <v-card elevation="2" class="dashboard-card product-card rounded-xl pa-4">
            <div class="product-content">
              <v-avatar :color="product.bg" size="68" class="product-avatar mr-4">
                <v-icon :color="product.color" size="36">{{ product.icon }}</v-icon>
              </v-avatar>
              <div class="product-info">
                <div class="dashboard-card-title">{{ product.nombre }}</div>
                <div class="product-amount">{{ product.valor }}</div>
                <div v-if="product.detalle" class="caption grey--text text--darken-1">{{ product.detalle }}</div>
              </div>
            </div>
            <v-btn
              block
              rounded
              :outlined="!product.filled"
              :depressed="product.filled"
              :dark="product.filled"
              :color="product.buttonColor"
              :to="product.to"
              class="product-button"
            >
              {{ product.accion }}
            </v-btn>
          </v-card>
        </v-col>
      </v-row>

      <template v-if="!userBits.b_socio">
        <v-row class="dashboard-row">
          <v-col cols="12" lg="8" class="non-member-stack">
            <v-card elevation="4" class="dashboard-card rounded-xl pa-5 mb-4">
              <div class="dashboard-section-title mb-4">Acciones rápidas</div>
              <div class="quick-actions">
                <router-link
                  v-for="action in inicioData.accionesRapidas"
                  :key="action.nombre"
                  :to="action.to"
                  class="quick-action"
                >
                  <div class="quick-icon mb-2" :style="{ backgroundColor: action.bg }">
                    <v-icon :color="action.color" size="28">{{ action.icon }}</v-icon>
                  </div>
                  <span>{{ action.nombre }}</span>
                </router-link>
              </div>
            </v-card>

            <v-card elevation="4" class="dashboard-card rounded-xl pa-5 non-member-movements-card">
              <div class="d-flex justify-space-between align-center mb-3">
                <div class="dashboard-section-title">
                  Próximos vencimientos
                  <!-- <v-icon x-small color="grey" class="ml-1">mdi-information-outline</v-icon> -->
                </div>
                <v-btn text small color="primary" :to="{ name: 'productos', params: { product: 'dap' } }">Ver todos</v-btn>
              </div>
              <div v-if="inicioData.proximosVencimientos.length" class="due-list">
              <router-link
                v-for="due in inicioData.proximosVencimientos"
                :key="`${due.producto}-${due.fecha}`"
                :to="due.to"
                class="due-item"
              >
                <v-avatar :color="due.bg" size="34" class="mr-3">
                  <v-icon :color="due.color" size="20">{{ due.icon }}</v-icon>
                </v-avatar>
                <div class="due-content">
                  <strong>{{ due.producto }}</strong>
                  <span>{{ due.fecha }} ({{ due.dias }} días)</span>
                </div>
                <div class="due-amount">{{ formatMonto(due.monto) }}</div>
                <v-icon small color="grey darken-1">mdi-chevron-right</v-icon>
              </router-link>
            </div>
            <div v-else class="empty-due-state">
              <div class="empty-due-illustration">
                <v-icon color="primary" size="58">mdi-calendar-month-outline</v-icon>
                <div class="empty-due-check">
                  <v-icon color="primary" size="18">mdi-check</v-icon>
                </div>
              </div>
              <strong>No tiene Depósitos a Plazo vigentes.</strong>
              <span>Cuando tengas depósitos próximos a vencer, aparecerán aquí automáticamente.</span>
              <v-btn
                rounded
                outlined
                small
                color="primary"
                class="empty-due-action"
                :to="{ name: 'simulador-dap'}"
              >
                <v-icon left small>mdi-calculator-variant-outline</v-icon>
                Simular nuevo DAP
              </v-btn>
            </div>
            </v-card>
          </v-col>

          <v-col cols="12" lg="4" class="non-member-interest-col">
            <v-card elevation="4" class="dashboard-card rounded-xl pa-4 fill-height interest-card">
              <div class="interest-header">
                <v-avatar color="#dff5e8" size="70" class="interest-avatar">
                  <v-icon color="#009b6b" size="38">mdi-sack</v-icon>
                </v-avatar>
                <div>
                  <div class="interest-title">Total intereses de tus inversiones</div>
                  <div class="interest-subtitle">Acumulado hasta hoy</div>
                  <div class="interest-amount">{{ formatMonto(interesesAcumuladosColocacion.total) }}</div>
                </div>
              </div>
              <v-divider class="my-4"></v-divider>
              <div class="interest-caption mb-4">
              </div>
              <div class="interest-breakdown">
                <div
                  class="interest-donut"
                  :style="{ background: interesesDonutGradient }"
                >
                  <span></span>
                </div>
                <div class="interest-list">
                  <div v-for="item in interesesAcumuladosColocacion.detalle" :key="item.label" class="interest-list-item">
                    <span class="distribution-dot" :style="{ backgroundColor: item.color }"></span>
                    <strong>{{ item.label }} ({{ item.porcentaje }}%)</strong>
                    <span>{{ formatMonto(item.monto) }}</span>
                  </div>
                </div>
              </div>
              <div class="interest-thanks mt-5">
                <v-avatar color="#e8f8ee" size="46" class="mr-3">
                  <v-icon color="#009b6b">mdi-heart-outline</v-icon>
                </v-avatar>
                <div>
                  <strong>Gracias por confiar en tu cooperativa</strong>
                  <span>Juntos seguimos construyendo tu futuro.</span>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <v-row v-if="userBits.b_socio" class="dashboard-row">
        <v-col cols="12" lg="6" v-if="userBits.b_socio">
          <v-card elevation="4" class="dashboard-card rounded-xl pa-5 fill-height">
            <div class="dashboard-section-title mb-4">
              Composición de mi cuenta de capital
              <!-- <v-icon x-small color="grey" class="ml-1">mdi-information-outline</v-icon> -->
            </div>
            <div class="capital-chart-layout">
              <div class="capital-chart-legend">
                <div class="capital-legend-title success--text">Aumentan el capital</div>
                <div
                  v-for="item in capitalPositiveItems"
                  :key="`legend-${item.label}`"
                  class="capital-legend-item"
                >
                  <span class="distribution-dot" :style="{ backgroundColor: item.color }"></span>
                  <span>{{ item.label }}</span>
                  <strong>{{ formatMonto(item.monto) }}</strong>
                </div>
                <v-divider class="my-3"></v-divider>
                <div class="capital-legend-title error--text">Disminuye el capital</div>
                <div
                  v-for="item in capitalNegativeItems"
                  :key="`legend-${item.label}`"
                  class="capital-legend-item"
                >
                  <span class="distribution-dot" :style="{ backgroundColor: item.color }"></span>
                  <span>{{ item.label }}</span>
                  <strong>-{{ formatMonto(Math.abs(item.monto)) }}</strong>
                </div>
              </div>
              
              <div class="capital-chart-area">
                <!-- <div class="capital-axis capital-axis-top">
                  <span>$0</span>
                  <span>$200 mil</span>
                  <span>$400 mil</span>
                  <span>$600 mil</span>
                  <span>$800 mil</span>
                </div> -->
                <div class="capital-bars">
                  <div
                    v-for="item in capitalPositiveItems"
                    :key="`bar-${item.label}`"
                    class="capital-bar-row"
                  >
                    <div class="capital-bar-positive" :style="{ width: item.width, backgroundColor: item.color }"></div>
                  </div>
                  <div class="capital-zero-line"></div>
                  <div
                    v-for="item in capitalNegativeItems"
                    :key="`bar-${item.label}`"
                    class="capital-bar-row capital-bar-row-negative"
                  >
                    <div class="capital-bar-negative" :style="{ width: item.width, backgroundColor: item.color }"></div>
                  </div>
                </div>
                <!-- <div class="capital-axis capital-axis-bottom">
                  <span>-$300 mil</span>
                  <span>-$200 mil</span>
                  <span>-$100 mil</span>
                  <span>$0</span>
                </div> -->
              </div>
            </div>
            <div class="capital-final-box mt-4">
              <div>
                <span>Saldo final de capital</span>
                <strong>{{ formatMonto(inicioData.capitalResumen.saldoTotal) }}</strong>
              </div>
              <!-- <v-avatar color="rgba(36, 202, 212, 0.16)" size="48">
                <v-icon color="primary">mdi-calendar-month</v-icon>
              </v-avatar> -->
              <!-- <p>El saldo final se obtiene sumando los componentes positivos y restando el cargo remanente negativo.</p> -->
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="6" lg="3" v-if="userBits.b_socio">
          <v-card elevation="4" class="dashboard-card rounded-xl pa-4 fill-height capital-card capital-summary-card">
            <div class="dashboard-section-title mb-4">
              Resumen de mi cuenta capital
              <!-- <v-icon x-small color="grey" class="ml-1">mdi-information-outline</v-icon> -->
            </div>
            <div class="capital-summary-grid mb-4">
              <div class="capital-summary-box capital-box-primary">
                <span>Saldo total de capital</span>
                <strong>{{ formatMonto(inicioData.capitalResumen.saldoTotal) }}</strong>
                <!-- <small>Equivale a {{ inicioData.capitalResumen.ufSaldo }}</small> -->
              </div>
              <div class="capital-summary-box capital-box-success" >
                <span>Disponible para solicitud  de giro</span>
                <strong>{{ formatMonto(inicioData.capitalResumen.disponibleRetiro) }}</strong>
                <!-- <small>Equivale a {{ inicioData.capitalResumen.ufDisponible }}</small> -->
              </div>
            </div>
            <div class="capital-detail-list">
              <div v-for="item in inicioData.capitalResumen.detalle" :key="item.label">
                <span>{{ item.label }}</span>
                <strong>{{ item.value }}</strong>
              </div>
            </div>
            <!-- <v-btn rounded text color="primary" class="capital-link mt-3 px-3">
              <span>Ver composición</span>
              <v-icon right small>mdi-chevron-right</v-icon>
            </v-btn> -->
          </v-card>
        </v-col>

        <v-col cols="12" md="6" lg="3">
          <v-card elevation="4" class="dashboard-card rounded-xl pa-4 fill-height interest-card">
            <div class="interest-header">
              <v-avatar color="#dff5e8" size="70" class="interest-avatar">
                <v-icon color="#009b6b" size="38">mdi-sack</v-icon>
              </v-avatar>
              <div>
                <div class="interest-title">Total intereses de tus inversiones</div>
                <div class="interest-subtitle">Acumulado hasta hoy</div>
                <div class="interest-amount">{{ formatMonto(interesesAcumuladosColocacion.total) }}</div>
                <!-- <div class="interest-growth">
                  <v-icon x-small color="#009b6b" class="mr-1">mdi-arrow-top-right</v-icon>
                  {{ interesesNetos.variacion }} vs año pasado
                </div> -->
              </div>
            </div>
            <v-divider class="my-4"></v-divider>
            <div class="interest-caption mb-4">
              <!-- Así se componen tus beneficios -->
            </div>
            <div class="interest-breakdown">
              <div
                class="interest-donut"
                :style="{ background: interesesDonutGradient }"
              >
                <span></span>
              </div>
              <div class="interest-list">
                <div v-for="item in interesesAcumuladosColocacion.detalle" :key="item.label" class="interest-list-item">
                  <span class="distribution-dot" :style="{ backgroundColor: item.color }"></span>
                  <strong>{{ item.label }} ({{ item.porcentaje }}%)</strong>
                  <span>{{ formatMonto(item.monto) }}</span>
                </div>
              </div>
            </div>
            <div class="interest-thanks mt-5">
              <v-avatar color="#e8f8ee" size="46" class="mr-3">
                <v-icon color="#009b6b">mdi-heart-outline</v-icon>
              </v-avatar>
              <div>
                <strong>Gracias por confiar en tu cooperativa</strong>
                <span>Juntos seguimos construyendo tu futuro.</span>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-if="userBits.b_socio" class="dashboard-row">
        <v-col cols="12" lg="5">
          <v-card elevation="4" class="dashboard-card rounded-xl pa-5 fill-height">
            <div class="dashboard-section-title mb-4">Acciones rápidas</div>
            <div class="quick-actions">
              <router-link
                v-for="action in inicioData.accionesRapidas"
                :key="action.nombre"
                :to="action.to"
                class="quick-action"
              >
                <div class="quick-icon mb-2" :style="{ backgroundColor: action.bg }">
                  <v-icon :color="action.color" size="28">{{ action.icon }}</v-icon>
                </div>
                <span>{{ action.nombre }}</span>
              </router-link>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" lg="7">
          <v-card elevation="4" class="dashboard-card rounded-xl pa-5 fill-height">
            <div class="d-flex justify-space-between align-center mb-3">
              <div class="dashboard-section-title">
                Próximos vencimientos
                <!-- <v-icon x-small color="grey" class="ml-1">mdi-information-outline</v-icon> -->
              </div>
              <v-btn text small color="primary" :to="{ name: 'productos', params: { product: 'dap' } }">Ver todos</v-btn>
            </div>
            <div v-if="inicioData.proximosVencimientos.length" class="due-list">
              <router-link
                v-for="due in inicioData.proximosVencimientos"
                :key="`${due.producto}-${due.fecha}`"
                :to="due.to"
                class="due-item"
              >
                <v-avatar :color="due.bg" size="34" class="mr-3">
                  <v-icon :color="due.color" size="20">{{ due.icon }}</v-icon>
                </v-avatar>
                <div class="due-content">
                  <strong>{{ due.producto }}</strong>
                  <span>{{ due.fecha }} ({{ due.dias }} días)</span>
                </div>
                <div class="due-amount">{{ formatMonto(due.monto) }}</div>
                <v-icon small color="grey darken-1">mdi-chevron-right</v-icon>
              </router-link>
            </div>
            <div v-else class="empty-due-state">
              <div class="empty-due-illustration">
                <v-icon color="primary" size="48">mdi-calendar-month-outline</v-icon>
                <div class="empty-due-check">
                  <v-icon color="primary" size="18">mdi-check</v-icon>
                </div>
              </div>
              <strong>No tiene Depósitos a Plazo vigentes.</strong>
              <span>Cuando tengas depósitos próximos a vencer, aparecerán aquí automáticamente.</span>
              <v-btn
                rounded
                outlined
                small
                color="primary"
                class="empty-due-action"
                :to="{ name: 'simulador-dap'}"
              >
                <v-icon left small>mdi-calculator-variant-outline</v-icon>
                Simular nuevo DAP
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <div class="dashboard-section-title mt-5 mb-5">Información y beneficios</div>
      <v-row class="dashboard-row">
        <v-col v-for="benefit in inicioData.beneficios" :key="benefit.titulo" cols="12" md="4">
          <v-card elevation="3" class="dashboard-card benefit-card rounded-xl pa-4" :to="benefit.to">
            <v-avatar :color="benefit.bg" size="54" class="mr-4">
              <v-icon :color="benefit.color" size="34">{{ benefit.icon }}</v-icon>
            </v-avatar>
            <div>
              <div class="dashboard-card-title">{{ benefit.titulo }}</div>
              <p class="caption grey--text text--darken-1 mb-1">{{ benefit.descripcion }}</p>
              <span class="benefit-link">{{ benefit.link }} <v-icon x-small color="primary">mdi-arrow-right</v-icon></span>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <mora-dialog v-if="dialogoMora" />
  </v-container>
</template>

<script>
import auth from "@/auth/auth";
import conv from "@/services/conversores";
import funciones from "@/services/funciones";
import MoraDialog from "@/components/inicio/MoraDialog.vue";
import { mapActions, mapState } from "vuex";
import CargandoApp from "@/components/app/CargandoApp.vue";
import home from "@/services/home";

export default {
  metaInfo: { title: "Inicio" },
  components: {
    "mora-dialog": MoraDialog,
    CargandoApp
  },
  data: function () {
    return {
      user: null,
      metaInfo: { title: "Inicio" },
      loading: true,
      inicioData: {
        patrimonio: {
          total: 0,
          variacion: "12%"
        },
        productos: [],
        capitalResumen: {
          saldoTotal: 0,
          disponibleRetiro: 0,
          ufSaldo: "0 UF",
          ufDisponible: "0 UF",
          detalle: []
        },
        interesesAcumuladosColocacion: null,
        capitalComposicion: [],
        proximosVencimientos: [],
        accionesRapidas: [],
        beneficios: []
      }
    };
  },
  computed: {
    ...mapState(["dialogoMora"]),
    ...mapState(["userBits"]),
    userLogged() {
      console.log(auth.getUserLogged())
      return auth.getUserLogged();
    },
    nombreUsuario() {
      const nombre = this.userLogged?.nombre || this.user?.nombre || "Socio";
      return conv.capitalizeString(nombre.split(" ")[0]);
    },
    personalInfo() {
      const direccion = this.user?.direccion_particular;
      const movil = this.user?.Movil;
      const email = this.user?.email_personal;

      return {
        direccion: direccion && direccion.trim().length > 0
          ? conv.capitalizeString(direccion.trim())
          : "No hay registro",
        movil: movil && parseInt(movil.trim()) > 0 ? movil.trim() : "No hay registro",
        email: funciones.validateEmail(email) ? email.toLowerCase().trim() : "No hay registro"
      };
    },
    activeProductsCount() {
      return this.inicioData.productos.filter((product) => product.status).length;
    },
    capitalPositiveItems() {
      return this.inicioData.capitalComposicion.filter((item) => item.monto >= 0);
    },
    capitalNegativeItems() {
      return this.inicioData.capitalComposicion.filter((item) => item.monto < 0);
    },
    interesesAcumuladosColocacion() {
      return this.inicioData.interesesAcumuladosColocacion
    },
    interesesDonutGradient() {
      if (!this.interesesAcumuladosColocacion?.total) {
        return "conic-gradient(#e9eef0 0% 100%)";
      }

      let cursor = 0;
      const segments = this.interesesAcumuladosColocacion.detalle.map((item) => {
        const start = cursor;
        cursor += Number(item.porcentaje) || 0;
        return `${item.color} ${start}% ${cursor}%`;
      });

      return `conic-gradient(${segments.join(", ")})`;
    },
    chartPoints() {
      const values = this.inicioData.evolucion.map((item) => item.monto);
      const min = 600000;
      const max = Math.max(1400000, ...values);
      const range = max - min || 1;
      const width = 520;
      const height = 110;
      const left = 86;
      const top = 58;

      return values.map((value, index) => ({
        x: left + (index * width) / (values.length - 1 || 1),
        y: top + height - ((value - min) / range) * height
      }));
    },
    linePoints() {
      return this.chartPoints.map((point) => `${point.x},${point.y}`).join(" ");
    },
    areaPoints() {
      if (!this.chartPoints.length) return "";
      return `86,170 ${this.linePoints} 606,170`;
    }
  },
  methods: {
    ...mapActions(["setPublicidades"]),
    formatMonto(value) {
      return conv.formatMonto(value || 0, true);
    },
    async getUserInfo() {
      await auth
        .userInfo(this.userLogged.id_cliente)
        .then((res) => {
          this.user = res.data;

          let dataUser = {
            tipo: this.user.b_empresa || 0,
            creditos: this.user.monto_creditos || 0,
            capital: this.user.monto_capital || 0,
            dap: this.user.monto_dap || 0,
            libretas: this.user.monto_libreta || 0
          };
          this.setPublicidades({ user: dataUser, mostrar: false });
        })
        .catch((error) => console.error(error));
    },  
    getPercentage(value, total) {
      if (!total) return 0;
      return Math.round((value / total) * 100);
    }
  },
  async mounted() {
    if (process.env.NODE_ENV !== "production") this.loading = true;
    await this.getUserInfo();
    this.inicioData = (await home.getHome()).data;
    this.loading = false;
  }
};
</script>

<style scoped lang="css">
.inicio-dashboard {
  color: #1f2d35;
  background: transparent;
  margin-left: auto;
  margin-right: auto;
  max-width: 1480px;
  min-height: calc(100vh - 40px);
  padding-bottom: 28px !important;
  padding-left: 24px !important;
  padding-right: 24px !important;
  padding-top: 24px !important;
}

.dashboard-header-row {
  margin-bottom: 18px;
}

.dashboard-header-row > .col,
.dashboard-row > .col,
.dashboard-row > [class*="col-"] {
  padding-bottom: 8px;
  padding-top: 8px;
}

.dashboard-title {
  color: var(--v-primary-base);
  font-size: 2.25rem;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 8px;
}

.dashboard-subtitle {
  color: #4d6870;
  font-size: 0.98rem;
}

.dashboard-card {
  width: 100%;
  background: #ffffff !important;
  border: 1px solid rgba(31, 45, 53, 0.08);
  box-shadow: 0 10px 28px rgba(20, 52, 57, 0.1) !important;
}

.patrimonio-card {
  height: 100%;
  min-height: 180px;
  background-image: linear-gradient(135deg, #006f70 0%, #068d91 48%, #00545a 100%);
  box-shadow: 0 12px 24px rgba(20, 52, 57, 0.28) !important;
  overflow: hidden;
  position: relative;
}

.patrimonio-card::before {
  background: radial-gradient(circle, rgba(36, 202, 212, 0.42) 0%, rgba(36, 202, 212, 0) 68%);
  content: "";
  height: 220px;
  position: absolute;
  right: -70px;
  top: -78px;
  width: 220px;
}

.patrimonio-card::after {
  background: linear-gradient(125deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 42%);
  content: "";
  height: 240px;
  left: 140px;
  position: absolute;
  top: -50px;
  transform: skewX(-18deg);
  width: 180px;
}

.patrimonio-content {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.dashboard-label {
  font-size: 0.98rem;
  font-weight: 600;
}

.patrimonio-amount {
  color: white;
  font-size: 2.75rem;
  font-weight: 800;
  letter-spacing: -1px;
  line-height: 1.18;
}

.patrimonio-subtitle {
  font-size: 1rem;
  font-weight: 500;
}

.patrimonio-meta {
  align-items: center;
  color: white;
  display: flex;
  gap: 12px;
}

.patrimonio-products {
  align-items: center;
  background: rgba(36, 202, 212, 0.25);
  border-radius: 9px;
  display: inline-flex;
  font-weight: 800;
  padding: 7px 12px;
}

.patrimonio-icon-wrap {
  align-items: center;
  background: rgba(36, 202, 212, 0.18);
  border-radius: 50%;
  display: flex;
  flex: 0 0 auto;
  height: 96px;
  justify-content: center;
  width: 96px;
}

.patrimonio-icon-ring {
  align-items: center;
  background: rgba(36, 202, 212, 0.6);
  border-radius: 50%;
  display: flex;
  height: 68px;
  justify-content: center;
  width: 68px;
}

.personal-card {
  background: linear-gradient(135deg, #ffffff 0%, rgba(36, 202, 212, 0.05) 100%) !important;
  overflow: hidden;
  padding: 0;
}

.personal-header {
  align-items: center;
  color: #20333a;
  display: flex;
  justify-content: space-between;
  min-height: 76px;
  padding: 18px 22px 12px;
}

.personal-title-wrap {
  align-items: center;
  display: flex;
  min-width: 0;
}

.personal-title {
  font-size: 1.28rem;
  font-weight: 700;
  line-height: 1.1;
}

.personal-subtitle {
  color: #4d6870;
  font-size: 0.82rem;
  margin-top: 3px;
}

.personal-content {
  display: grid;
  background: #ffffff;
  border: 1px solid rgba(37, 108, 116, 0.1);
  border-radius: 14px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.55);
  gap: 0;
  grid-template-columns: minmax(230px, 1.35fr) minmax(150px, 0.75fr) minmax(210px, 1fr);
  margin: 0 20px 20px;
  padding: 20px;
}

.personal-item {
  align-items: flex-start;
  display: flex;
  gap: 11px;
  min-width: 0;
  padding: 0 18px;
}

.personal-item + .personal-item {
  border-left: 1px solid rgba(37, 108, 116, 0.14);
}

.personal-icon {
  align-items: center;
  border-radius: 12px;
  display: flex;
  flex: 0 0 auto;
  height: 48px;
  justify-content: center;
  width: 48px;
}

.personal-icon-primary {
  background: rgba(37, 108, 116, 0.12);
}

.personal-icon-secondary {
  background: rgba(36, 202, 212, 0.16);
}

.personal-icon-accent {
  background: rgba(37, 108, 116, 0.09);
}

.personal-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.personal-label {
  color: #60757b;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin-bottom: 3px;
  text-transform: uppercase;
}

.personal-item strong {
  color: #20333a;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.product-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 150px;
  padding: 18px 20px 16px !important;
}

.product-content {
  align-items: center;
  display: flex;
  margin-bottom: 14px;
}

.product-avatar {
  flex: 0 0 auto;
}

.product-info {
  min-width: 0;
}

.product-button {
  height: 34px !important;
  text-transform: none;
  font-weight: 700;
}

.dashboard-card-title,
.dashboard-section-title {
  color: #20333a;
  font-weight: 700;
}

.dashboard-card-title {
  font-size: 0.94rem;
  line-height: 1.2;
}

.dashboard-section-title {
  font-size: 1.05rem;
}

.product-amount {
  color: #20333a;
  font-size: 1.38rem;
  font-weight: 400;
  line-height: 1.25;
}

.distribution-layout {
  align-items: center;
  display: flex;
  gap: 30px;
  min-height: 170px;
}

.donut-chart {
  align-items: center;
  border-radius: 50%;
  display: flex;
  flex: 0 0 150px;
  height: 150px;
  justify-content: center;
  position: relative;
  width: 150px;
}

.donut-chart::after {
  background: white;
  border-radius: 50%;
  content: "";
  height: 76px;
  position: absolute;
  width: 76px;
}

.donut-center {
  color: #20333a;
  font-size: 1.12rem;
  font-weight: 800;
  position: relative;
  z-index: 1;
}

.distribution-list {
  flex: 1;
  min-width: 0;
}

.distribution-item {
  align-items: center;
  display: grid;
  gap: 8px;
  grid-template-columns: 12px minmax(140px, 1fr) 52px 100px;
  margin-bottom: 12px;
}

.distribution-dot {
  border-radius: 50%;
  height: 10px;
  width: 10px;
}

.distribution-name,
.distribution-percent,
.distribution-value {
  font-size: 0.9rem;
}

.distribution-value {
  font-weight: 700;
  text-align: right;
}

.distribution-total {
  align-items: center;
  background: #f2f7ff;
  border-radius: 8px;
  color: var(--v-primary-base);
  display: flex;
  justify-content: space-between;
  padding: 10px 12px;
}

.distribution-total strong {
  font-size: 1rem;
}

.dashboard-inner-row > .col,
.dashboard-inner-row > [class*="col-"] {
  padding-bottom: 0;
  padding-top: 0;
}

.capital-summary-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr;
}

.capital-summary-box {
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  min-height: auto;
  padding: 11px 12px;
}

.capital-box-primary {
  background: linear-gradient(135deg, #f2f6ff 0%, #ffffff 100%);
}

.capital-box-success {
  background: linear-gradient(135deg, #eef9ef 0%, #ffffff 100%);
}

.capital-summary-box span,
.capital-detail-list span,
.capital-composition-item span,
.due-content span {
  color: #5f7278;
  font-size: 0.78rem;
}

.capital-summary-box strong {
  color: #20333a;
  font-size: 1.2rem;
  line-height: 1.3;
}

.capital-box-success strong {
  color: #138a37;
}

.capital-summary-box small,
.capital-composition-item small {
  color: #5f7278;
  font-size: 0.72rem;
}

.capital-detail-list div {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
}

.capital-detail-list strong,
.due-amount {
  color: #20333a;
  font-size: 0.86rem;
  font-weight: 700;
}

.capital-link {
  background: #f2f7ff;
  align-self: flex-start;
  justify-content: flex-start;
  min-width: 0 !important;
  text-transform: none;
}

::v-deep .capital-link .v-btn__content {
  justify-content: flex-start;
  min-width: 0;
}

.capital-link span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.capital-summary-card,
.interest-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.capital-summary-card .capital-link,
.interest-thanks {
  margin-top: auto !important;
}

.capital-composition-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.capital-composition-item {
  align-items: center;
  display: grid;
  gap: 10px;
  grid-template-columns: 145px minmax(90px, 1fr) 78px 48px;
}

.capital-bar-track {
  background: #eef0f3;
  border-radius: 2px;
  height: 12px;
  overflow: hidden;
}

.capital-bar-fill {
  height: 100%;
}

.capital-total-row {
  align-items: center;
  background: #f2f7ff;
  border-radius: 8px;
  color: var(--v-primary-base);
  display: flex;
  justify-content: space-between;
  padding: 10px 12px;
}

.capital-total-row strong {
  font-size: 1rem;
}

.capital-chart-layout {
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(230px, 0.95fr) minmax(260px, 1.35fr);
  min-height: 250px;
}

.capital-chart-legend {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.capital-legend-title {
  font-size: 0.86rem;
  font-weight: 800;
  margin-bottom: 10px;
}

.capital-legend-item {
  align-items: center;
  color: #42565d;
  display: grid;
  gap: 10px;
  grid-template-columns: 12px minmax(110px, 1fr) 88px;
  margin-bottom: 14px;
}

.capital-legend-item span,
.capital-legend-item strong {
  font-size: 0.84rem;
}

.capital-legend-item strong {
  color: #20333a;
  font-weight: 800;
  text-align: right;
}

.capital-chart-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

.capital-axis {
  color: #60757b;
  display: flex;
  font-size: 0.76rem;
  justify-content: space-between;
}

.capital-axis-top {
  margin-left: 18px;
}

.capital-axis-bottom {
  margin-left: -78px;
  margin-right: auto;
  max-width: 210px;
}

.capital-bars {
  background-image: linear-gradient(to right, rgba(37, 108, 116, 0.13) 1px, transparent 1px);
  background-size: 25% 100%;
  border-left: 2px solid rgba(31, 45, 53, 0.45);
  margin: 9px 10px 8px 18px;
  padding: 8px 0 8px;
  position: relative;
}

.capital-bar-row {
  align-items: center;
  display: flex;
  height: 34px;
}

.capital-bar-row-negative {
  justify-content: flex-start;
  transform: translateX(-100%);
  width: 100%;
}

.capital-bar-positive,
.capital-bar-negative {
  border-radius: 2px;
  height: 15px;
}

.capital-bar-negative {
  margin-left: auto;
}

.capital-zero-line {
  border-top: 1px solid rgba(31, 45, 53, 0.22);
  height: 14px;
  margin: 2px 0 7px;
}

.capital-final-box {
  align-items: center;
  background: #f2f7ff;
  border: 1px solid rgba(37, 108, 116, 0.1);
  border-radius: 9px;
  display: grid;
  gap: 14px;
  grid-template-columns: minmax(145px, 0.8fr) 48px minmax(210px, 1.2fr);
  padding: 14px 16px;
}

.capital-final-box span {
  color: var(--v-primary-base);
  display: block;
  font-weight: 700;
}

.capital-final-box strong {
  color: var(--v-primary-base);
  display: block;
  font-size: 1.55rem;
  line-height: 1.2;
}

.capital-final-box p {
  color: #60757b;
  font-size: 0.78rem;
  line-height: 1.35;
  margin: 0;
}

.interest-card {
  background: linear-gradient(135deg, #ffffff 0%, #f7fbf8 100%) !important;
  border-color: rgba(0, 155, 107, 0.12);
}

.interest-header {
  align-items: flex-start;
  display: flex;
  gap: 14px;
}

.interest-avatar {
  flex: 0 0 auto;
}

.interest-title {
  color: #1c2c3d;
  font-size: 0.88rem;
  font-weight: 800;
  line-height: 1.2;
}

.interest-subtitle,
.interest-caption {
  color: #455a72;
  font-size: 0.8rem;
}

.interest-amount {
  color: #008b60;
  font-size: 1.55rem;
  font-weight: 800;
  line-height: 1.2;
  margin-top: 6px;
}

.interest-growth {
  align-items: center;
  background: #dff5e8;
  border-radius: 999px;
  color: #008b60;
  display: inline-flex;
  font-size: 0.72rem;
  font-weight: 800;
  margin-top: 10px;
  padding: 4px 10px;
}

.interest-breakdown {
  align-items: center;
  display: grid;
  gap: 14px;
  grid-template-columns: 92px minmax(0, 1fr);
}

.interest-donut {
  align-items: center;
  border-radius: 50%;
  display: flex;
  height: 92px;
  justify-content: center;
  width: 92px;
}

.interest-donut span {
  background: #ffffff;
  border-radius: 50%;
  height: 44px;
  width: 44px;
}

.interest-list {
  display: flex;
  flex-direction: column;
  gap: 13px;
}

.interest-list-item {
  align-items: center;
  color: #1c2c3d;
  display: grid;
  gap: 8px;
  grid-template-columns: 10px minmax(64px, 1fr) 74px;
}

.interest-list-item strong,
.interest-list-item span {
  font-size: 0.78rem;
}

.interest-list-item strong {
  font-weight: 800;
}

.interest-list-item span:last-child {
  font-weight: 700;
  text-align: right;
}

.interest-thanks {
  align-items: center;
  background: rgba(37, 108, 116, 0.07);
  border-radius: 10px;
  display: flex;
  padding: 10px 12px;
}

.interest-thanks strong {
  color: var(--v-primary-base);
  display: block;
  font-size: 0.82rem;
}

.interest-thanks span {
  color: #455a72;
  display: block;
  font-size: 0.8rem;
  line-height: 1.25;
}

.line-chart {
  height: 172px;
  position: relative;
}

.chart-grid {
  background-image: linear-gradient(to bottom, rgba(31, 45, 53, 0.12) 1px, transparent 1px);
  background-size: 100% 34px;
  bottom: 32px;
  left: 74px;
  position: absolute;
  right: 16px;
  top: 38px;
}

.chart-y-labels {
  bottom: 28px;
  color: #52666d;
  display: flex;
  flex-direction: column;
  font-size: 0.82rem;
  justify-content: space-between;
  left: 0;
  position: absolute;
  top: 30px;
  width: 72px;
}

.chart-value {
  fill: #20333a;
  font-size: 12px;
  font-weight: 700;
}

.chart-labels {
  color: #60757b;
  display: flex;
  font-size: 0.85rem;
  justify-content: space-between;
  padding: 0 22px 0 86px;
}

.quick-actions {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(5, minmax(70px, 1fr));
  min-height: 104px;
  padding-top: 6px;
}

.quick-action {
  align-items: center;
  color: #20333a;
  display: flex;
  flex-direction: column;
  font-size: 0.78rem;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
}

.quick-icon {
  align-items: center;
  border-radius: 10px;
  display: flex;
  height: 54px;
  justify-content: center;
  width: 54px;
}

.non-member-stack,
.non-member-interest-col {
  display: flex;
  flex-direction: column;
}

.non-member-movements-card {
  flex: 1 1 auto;
}

.empty-due-state {
  align-items: center;
  color: #60757b;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 178px;
  padding: 10px 16px 14px;
  text-align: center;
}

.empty-due-illustration {
  align-items: center;
  background: linear-gradient(180deg, rgba(36, 202, 212, 0.11) 0%, rgba(36, 202, 212, 0.04) 100%);
  border-radius: 50%;
  display: flex;
  height: 72px;
  justify-content: center;
  margin-bottom: 8px;
  position: relative;
  width: 72px;
}

.empty-due-illustration > .v-icon {
  font-size: 34px !important;
}

.empty-due-check {
  align-items: center;
  background: #ffffff;
  border: 2px solid var(--v-primary-base);
  border-radius: 50%;
  bottom: 8px;
  box-shadow: 0 5px 12px rgba(20, 52, 57, 0.12);
  display: flex;
  height: 23px;
  justify-content: center;
  position: absolute;
  right: 9px;
  width: 23px;
}

.empty-due-state strong {
  color: #20333a;
  font-size: 0.92rem;
  font-weight: 800;
  margin-bottom: 5px;
}

.empty-due-state span {
  font-size: 0.78rem;
  line-height: 1.45;
  max-width: 360px;
}

.empty-due-action {
  font-size: 0.78rem;
  font-weight: 800;
  margin-top: 10px;
  text-transform: none;
}

.due-item {
  align-items: center;
  border-bottom: 1px solid rgba(37, 108, 116, 0.1);
  color: #20333a;
  display: flex;
  padding: 9px 0;
  text-decoration: none;
}

.due-item:last-child {
  border-bottom: 0;
}

.due-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.due-amount {
  color: var(--v-primary-base);
  font-weight: 800;
  margin-left: 10px;
  margin-right: 10px;
}

.benefit-card {
  align-items: center;
  display: flex;
  min-height: 90px;
  text-decoration: none;
}

@media (min-width: 1904px) {
  .inicio-dashboard {
    max-width: 1480px;
  }
}

.benefit-link {
  color: var(--v-primary-base);
  font-size: 0.9rem;
  font-weight: 700;
}

@media (max-width: 1263px) {
  .distribution-layout {
    align-items: flex-start;
  }
}

@media (max-width: 959px) {
  .quick-actions {
    grid-template-columns: repeat(3, minmax(80px, 1fr));
  }

  .personal-content {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 599px) {
  .distribution-layout {
    flex-direction: column;
  }

  .distribution-item {
    grid-template-columns: 12px minmax(110px, 1fr) 34px 90px;
  }

  .quick-actions {
    grid-template-columns: repeat(2, minmax(100px, 1fr));
  }

  .due-item {
    align-items: flex-start;
  }

  .due-amount {
    font-size: 0.85rem;
  }
}
</style>
